import React from 'react';
import { useAuth } from '../../context/AuthContext';

export default function UserDashboard() {
  const { user } = useAuth();

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-8">Mijn Dashboard</h1>
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-2xl">
        <div className="flex items-center gap-6 mb-8">
          <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-blue-500 rounded-full flex items-center justify-center text-white text-3xl font-bold">
            {user?.name?.charAt(0) || 'G'}
          </div>
          <div>
            <h2 className="text-2xl font-bold">{user?.name || 'Gebruiker'}</h2>
            <p className="text-gray-600">{user?.email || 'gebruiker@politiekdirect.nl'}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="text-3xl font-bold text-blue-600">12</div>
            <div className="text-gray-600">Artikelen gelezen</div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="text-3xl font-bold text-green-600">3</div>
            <div className="text-gray-600">Reacties geplaatst</div>
          </div>
        </div>
      </div>
    </div>
  );
}
